// Libraries
import { Icon, IconProps } from '@chakra-ui/react';

/**
 * Component that renders the Vessel Profiler Icon.
 * @param {IconProps} props - The IconProps for the VesselProfilerIcon component.
 * @returns {ReactElement} The VesselProfilerIcon component.
 */
export const VesselProfilerIcon = (props: IconProps) => {
  const { color = '#25CAD2', ...rest } = props;
  return (
    <Icon width='35' height='33' viewBox='0 0 35 33' color={color} fill='transparent' {...rest} id='vessel-profiler'>
      <path
        d='M17.0803 1.07495V8.00495'
        stroke='currentColor'
        strokeWidth='2.15'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M7.32701 29.475C3.10499 26.615 3.81543 19.345 3.81543 19.345L17.0803 13.545V20.995'
        stroke='currentColor'
        strokeWidth='2.15'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M17.0803 13.545L30.3452 19.345C30.3452 19.345 30.8831 24.865 28.224 28.175'
        stroke='currentColor'
        strokeWidth='2.15'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M26.8843 12.765V17.855'
        stroke='currentColor'
        strokeWidth='2.15'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M7.26624 17.815V9.13505C7.26624 7.50505 8.60591 6.17505 10.2704 6.17505H21.8403'
        stroke='currentColor'
        strokeWidth='2.15'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M1.0752 27.895C2.59756 30.985 6.4339 32.115 9.95563 29.965C10.8386 29.425 11.752 28.175 13.5991 28.215C15.3346 28.255 15.6594 29.285 17.2122 30.045C18.8462 30.845 20.8456 30.875 22.4999 30.125C23.3625 29.725 24.1339 29.135 24.9965 28.735C27.7571 27.445 31.4108 28.465 33.0752 30.995'
        stroke='currentColor'
        strokeWidth='2.15'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M26.8843 12.555C29.6701 12.555 31.9284 10.3298 31.9284 7.58499C31.9284 4.84014 29.6701 2.61499 26.8843 2.61499C24.0985 2.61499 21.8402 4.84014 21.8402 7.58499C21.8402 10.3298 24.0985 12.555 26.8843 12.555Z'
        stroke='currentColor'
        strokeWidth='1.79'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M26.8843 5.76505C27.2935 5.76505 27.6252 5.43822 27.6252 5.03505C27.6252 4.63189 27.2935 4.30505 26.8843 4.30505C26.4751 4.30505 26.1434 4.63189 26.1434 5.03505C26.1434 5.43822 26.4751 5.76505 26.8843 5.76505Z'
        fill='currentColor'
      />
      <path d='M25.301 6.97498H26.8843V10.045H25.301' stroke='currentColor' strokeWidth='1.5' strokeMiterlimit='10' />
      <path d='M26.8843 10.045H28.4777' stroke='currentColor' strokeWidth='1.5' strokeMiterlimit='10' />
    </Icon>
  );
};
